export const SET_EDIT_MODE = "projectDashboardReducer/SET_EDIT_MODE";
export const SET_ACTIVE_LAYOUT = "projectDashboardReducer/SET_ACTIVE_LAYOUT";
export const SET_ALL_LAYOUTS = "projectDashboardReducer/SET_ALL_LAYOUTS";

export const dashboardInfo = `


### Opprette og redigere oppsett

* **Opprette nytt oppsett:** Klikk på plussikonet, velg om du vil kopiere et eksisterende oppsett eller starte tomt, skriv inn tittel og lagre.
* **Legge til og fjerne widgets:** Bruk nedtrekksmenyen for å legge til eller fjerne widgets.
* **Flytte og endre størrelse:** Flytt widgets ved å klikke og dra. Endre størrelse ved å dra i nedre høyre hjørne, eller langs nedre eller høyre kant. Hvis innholdet ikke skaleres riktig, oppdater siden etter at du har lagret for å se endringene.
* **Lagre eller avbryte:** Klikk den blå lagre-knappen for å lagre, eller klikk X-knappen for å avbryte.
* **Redigere et eksisterende oppsett:** Velg oppsettet, klikk på blyantikonet, og rediger etter samme prosedyre som for nye oppsett.

---

### Prosjektadministratorer og oppsett

- Prosjektadministratorer lagrer oppsett som blir tilgjengelige for hele prosjektet.
- Ikke-administratorer lagrer oppsett som kun er synlige for dem selv.
- Når et prosjekt opprettes, genererer MCApps noen grunnleggende oppsett.
- Prosjektadministratorer kan velge genererte eller tilpassede oppsett som standard via lenken «velg standardoppsett».


---


### Widgetinnstillinger

- Widgets kan ha egne innstillinger i sine respektive vinduer.
- Klikk pil-ikonet for å åpne en større visning; klikk utenfor for å lukke.
- Klikk på de tre prikkene for widgetspesifikke alternativer, for eksempel å legge til elementer eller endre filtre.


`;
